/**
 * Created by hanan on 16/11/28.
 */

require('./index.scss');
require('common/header/header.js');
require('common/css/footer.scss');
require('common/css/normalize.scss');
require('public/jquery/chosen/chosen.css');
require('public/jquery/chosen/chosen.jquery.js');

var Apply = require('../common/apply/apply');
/*该文件问页面的js部分，引入header和footer以及body部分的scss*/

$(function(){


  var docWidth;
  var smallWidth;
  //图片宽度
  var imgWidth;
  var autoChange;
  //当前index
  var curIndex = 0;
  //定时器自动变换2.5秒一次
  var autoTime=3000;
  //图片总数
  var imgLen = $('.img-list li').length;


  function recalc(){
    // clearInterval(autoChange);
    docWidth=$(document.body).width() > 1080 ? $(document.body).width()  : 1080;

    smallWidth=$('.index-list').width();
    $('.index-list').css('right',(docWidth-smallWidth)/2);

    $('.img-list li').css('width',docWidth);
    //$('.img-list li a').css('width',docWidth);
    var len = $('.img-list li').length ;
    $('.img-list').css('width',docWidth*len);
    $('#banner').css('width',docWidth);
    imgWidth=$('.img-list li').width();

    $('.index-list').css('right',docWidth*0.465+'px')
    // changeTime();
    // console.log('执行time');
    // time();
    let goLeft = curIndex * imgWidth;
    $('.img-list').css('left',goLeft + 'px');

    autoChangeAgain();
  }
  recalc();

  // changeTime();


  /**
   * 函数节流方法
   * @param Function fn 延时调用函数
   * @param Number delay 延迟多长时间
   * @param Number atleast 至少多长时间触发一次
   * @return Function 延迟执行的方法
   */
  var throttle = function (fn, delay, atleast) {
    console.log('throttle');
      var timer = null;
      var previous = null;

      return function () {
          var now = new Date();

          if ( !previous ) previous = now;

          if ( now - previous > atleast ) {
              fn();
              // 重置上一次开始时间为本次结束时间
              previous = now;
          } else {
              clearTimeout(timer);
              timer = setTimeout(function() {
                  fn();
              }, delay);
          }
      }
  };
  var f = throttle(recalc, 250,1000);
  $(window).resize(function(){f();});

  // window.addEventListener("resize", function(){f();}, false);


  if(imgLen<=1){
    $('#prev').addClass('hide');
    $('#next').addClass('hide');
    $('.index-list li').addClass('hide');
  }

  //鼠标移入banner停止运动，移出的开始运动
  $('#banner').mouseenter(function(){
    clearInterval(autoChange);
  }).mouseleave(function(){
    autoChangeAgain();
  });
  //左箭头点击处理
  $('#prev').click(function(){
    //根据curIndex进行上一个图片处理
    curIndex = (curIndex > 0) ? (--curIndex) : (imgLen - 1);
    changeTo(curIndex);
  });
  //右箭头点击处理
  $('#next').click(function(){
    curIndex = (curIndex < imgLen - 1) ? (++curIndex) : 0;
    changeTo(curIndex);
  });
  //对下方的小圆圈进行事件绑定处理等
  $('.index-list').find('li').each(function(item){
    $(this).click(function(){
        clearInterval(autoChange);
        curIndex=item;
        changeTo(item);
      }
    );
  });
  //清除定时器时候的重置定时器--封装
  function autoChangeAgain(){
    clearInterval(autoChange);
    autoChange = setInterval(time,autoTime);
  }

  function time(){
    if(curIndex < imgLen-1){
      curIndex ++;
    }else{
      curIndex = 0;
    }
    //调用变换处理函数

    changeTo(curIndex);
  }
  $('.index-list li:first').addClass('dark');
  function changeTo(num){
    var goLeft = num * imgWidth;
    $('.img-list').animate({left: '-' + goLeft + 'px'},500);
    // console.log(num);
    $('.index-list').find('li').removeClass('dark');
    $('.index-list').find('li').eq(num).addClass('dark');
  }


  /*产品特点-滑动效果*/
  $('.icon>div.item').each(function(){
    $(this).hover(function(){
      $(this).find('div.text').slideToggle();
    });
  });

  /*产品案例-立即申请部分*/
  //鼠标移入移出改变背景图片
  $('.product-case-left .case-right p').mouseenter(function () {
    $(this).parents('.product-case-left').find('.btn img')
      .attr('src','/static/common/images/button-before.png');
    $(this).parents('.case-right').find('img')
      .attr('src','/static/common/images/button-after.png');
  });

  $('.product-case-left .case-right p').mouseleave(function () {
    $(this).parents('.product-case-left').find('.case-right img')
      .attr('src','/static/common/images/button-before.png');
  });

  //点击查看详情
  //点击查看详情，内容变换小三角位置改变
  $('.product-case-left .case-right .detail').click(function(){
    var num=$(this).parents('.case').index();
    $(this).parents('.product-case-content').find('.product-item').removeAttr('id');
    $(this).parents('.product-case-content').children('.product-case-right')
      .children('.product-item:eq('+num+')').attr('id','show');

    $(this).parents('.product-case-content').children("[class^='angle']").not('.angle'+num).hide();
    $(this).parents('.product-case-content').children('.angle'+num).show();
  });

  //新闻部分文字处理
  $('.news-content-right .item-content .short').each(function () {
    $(this).find('p:lt(2)').remove();
  });
  $('.news-content .item-content').each(function () {
    $(this).find('.short').text($(this).find('.short').text());
  });

  // 百度统计埋点
  let detailButtonClicked = false;
  let detailProductNameClicked = '';
  let applyProductNameClicked = '';
  $('.product-case-left .case a').on('click', function () {
    let text = $(this).text();
    let productName = $(this).closest('.case').find('.case-mid h3').text();
    let trackEventCategory;
    if (text == '查看详情') {
      trackEventCategory = 'detail-button';
      detailProductNameClicked = productName;
      detailButtonClicked = true;
    }
    else {
      if (detailButtonClicked) {
        _hmt.push(['_trackEvent', 'detail-apply-button', 'click', `home-${detailProductNameClicked}-${productName}`]);
      }
      trackEventCategory = 'apply-button';
      applyProductNameClicked = productName;
      detailButtonClicked = false;
    }
    _hmt.push(['_trackEvent', trackEventCategory, 'click', `home-${productName}`]);
  });

  // 提交弹层
  var applyDialog = Apply.create();
  applyDialog.on('apply', () => {
    _hmt.push(['_trackEvent', 'form', 'apply-success', `home-${applyProductNameClicked}`]);
  });
  $('.case-right p').click(function () {
    applyDialog.show();
  });

  var cityMap = {};
  var branchMap = {};

  $('.apply-form [name=provinceCode]').on('change', function () {
    getCity($(this).val());
  });

  // 发送短信验证码按钮
  $('.apply-form .apply-send-smscode').on('click', function () {
    sendSms();
  });

  // 验证提交按钮是否可点
  $('.apply-form select').on('change', function () {
    vilidate();
  });
  $('.apply-form input').on('keyup', function () {
    vilidate();
  });

  // 点击提交按钮
  $('.apply-form .apply-confirm').on('click', function () {
    apply();
  });

  //点击图片验证码
  $('.apply-form .code-img').on('click', function () {
    captchaCode();
  });

  //getProvince();

  $('.apply-form select').chosen();
  $('.apply-form select').trigger('change');

function renderSelect(el, list) {
  el.empty().append('<option value="请选择">' + (el.data('placeholder') || '请选择') + '</option>').val('请选择').trigger('change');
  for (var i = 0; i < list.length; i++) {
    el.append('<option value="' + list[i].value + '" data-id="' + list[i].id + '">' + list[i].name + '</option>');
  }
  el.trigger("chosen:updated").trigger('change');
}

  // 获取省份下拉信息
  function getProvince() {
    var provinceList = [];
    var el = $('[name=provinceCode]');
    var api = 'https://lendapp.finupcredit.com/lend-app/customerOfficialwWebsite/appOfficialwWebsiteController/getCityMethod';
    $.ajax({
      url: api,
      dataType: 'jsonp',
      success: function (result) {
        if (result.length) {
          var items = result[0].items;
          for (var i = 0; i < items.length; i++) {
            var p = items[i];
            if (p.city.length) {
              cityMap[p.name] = p.city;
              provinceList.push({
                name: p.name,
                value: p.name
              });
            }
          }
          renderSelect(el, provinceList);
        }
      }
    });
  }

  // 获取城市下拉信息
 function  getCity(province) {
    var cityList = [];
    var list = cityMap[province] || [];
    for (var j = 0; j < list.length; j++) {
      cityList.push({
        id: list[j].id,
        name: list[j].cityName,
        value: list[j].cityCode
      });
    }
    renderSelect($('.apply-form [name=cityCode]'), cityList);
  }
    // 发送验证码
  function sendSms() {

    var btn = $('.apply-form .apply-send-smscode');
    var mobile = $('.apply-form [name=mobile]').val();
    var captchaCode = $('.apply-form [name=captchaCode]').val().toLowerCase();

    if (btn.hasClass('second')) {
      return;
    }

    if (!/^\d{11}$/.test(mobile)) {
      return alert('手机号码格式错误，请重新输入。');
    }
    if(!/^[a-zA-Z0-9]{5}$/.test(captchaCode)){
      return alert('图形验证码不正确！');
    }
   
    $(btn).addClass('second').text(90);
    var msmcodeTimer = setInterval(function () {
      var time = btn.text() | 0;
      if (time <= 0) {
        unlock();
      }
      else {
        btn.text(--time);
      }
    }, 1000);

    function unlock() {
      btn.removeClass('second').text('发送验证码')
      clearInterval(msmcodeTimer);
    }
    $.ajax({
      url: '/api/smscode',
      type: 'post',
      data: {
        mobile: mobile,
        captchaCode:captchaCode,
      },
      dataType: 'json',
      success: function (data) {
        if (!data.code) {
          unlock();
        }else if(data.code == '-2'){
          unlock();
          alert(data.message)
        }
        // alert(data.message);
      },
      error: function () {
        unlock();
        alert('提示信息', '请求出现错误！');
      }
    });
  }

  // 表单验证
  function vilidate() {
    var mobile = $('.apply-form [name=mobile]').val();
    var smscode = $('.apply-form [name=smscode]').val();
    var provinceCode = $('.apply-form [name=provinceCode]').val();
    var cityCode = $('.apply-form [name=cityCode]').val();
    var btn = $('.apply-form .apply-confirm');
    provinceCode = provinceCode == '请选择' ? '' : provinceCode;
    cityCode = cityCode == '请选择' ? '' : cityCode;

    if (/^\d{11}$/.test(mobile) && smscode && provinceCode && cityCode ) {
      btn.removeClass('disable');
    }
    else {
      btn.addClass('disable');
    }
  }

  // 提交申请
  function apply() {
    var self = this;
    var btn = $('.apply-form .apply-confirm');
    var waiting = $('.apply-wrap .waiting');
    if (!btn.hasClass('disable')) {
      var mobile = $('.apply-form [name=mobile]').val();
      var smscode = $('.apply-form [name=smscode]').val();
      var provinceCode = $('.apply-form [name=provinceCode]').val();
      var province = $('.apply-form [name=provinceCode]').find(':selected').text();
      var cityCode = $('.apply-form [name=cityCode]').val();
      var city = $('.apply-form [name=cityCode]').find(':selected').text();
      var channel = 3;
      var submitChannel = 'PC';
      var position = 'advertisement';

      btn.addClass('disable');

      waiting.show();

      $.ajax({
        url: '/api/apply',
        type: "post",
        dataType: "json",
        data: {mobile, smscode, province, provinceCode, city, cityCode, channel, submitChannel,position},
        success: function (data) {
          btn.removeClass('disable');
          waiting.hide();
          if (data.code == 1) {
            clear();
            alert('您的申请已提交。');
          }
          else {
            alert(data.message || data.msg || '申请失败，请重试');
          }

        },
        error: function () {
          alert('请求出现错误');
          btn.removeClass('disable');
          waiting.hide();
        }
      });
    }
  }

  // 清空表单
  function clear() {
    $('.apply-form input').val('').trigger('change');
    $('.apply-form [name=provinceCode]').val('请选择').trigger("chosen:updated").trigger('change');
    $('.apply-form .apply-confirm').addClass('disable');
  }
  //captchaCode();
  // 获取短信验证码
  function captchaCode(num) {

    $.ajax({
      url: '/api/captcha',
      type: 'post',
      data: {},
      dataType: 'json',
      success: function (data) {
        if (data.code == 1) {
          $('.apply-form .code-img').attr("src",data.img);
        }
        // alert(data.message);
      },
      error: function () {
        alert('提示信息', '请求出现错误！');
      }
    });
  }

});



// WEBPACK FOOTER //
// ./static/home/index.js